import React, { ComponentProps } from 'react';

import ProjectPageLayout from '@adsk/alloy-project-page-layout';
import { PRODUCT_IDS, TOOL_IDS } from '@adsk/alloy-provider';
import SideNavigation from '@adsk/alloy-side-navigation';
import { TabTitle } from '@adsk/exo-skeleton-react';

import { Route, LAYOUTS } from './types';
import RemoteSideNavigation from '../components/RemoteSideNavigation/RemoteSideNavigation';

export default [
  {
    path: '/build/demo-app/*',
    scope: 'accDemoApp',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: 'demo-app',
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/correspondence/*',
    scope: 'accCorrespondence',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.CORRESPONDENCE,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/dc/correspondence/*',
    scope: 'accCorrespondence',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.CORRESPONDENCE,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
    },
  },
  {
    path: '/model/correspondence/*',
    scope: 'accCorrespondence',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.CORRESPONDENCE,
      currentProductId: PRODUCT_IDS.MODEL_COORDINATION,
    },
  },
  {
    path: '/build/meetings/*',
    scope: 'accMeetings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.MEETINGS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/model/meetings/*',
    scope: 'accMeetings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.MEETINGS,
      currentProductId: PRODUCT_IDS.MODEL_COORDINATION,
    },
  },
  {
    path: '/dc/meetings/*',
    scope: 'accMeetings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.MEETINGS,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
    },
  },
  {
    path: '/build/rfis/*',
    scope: 'accRfis',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.RFIS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/photos/*',
    scope: 'acsPhotos',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.PHOTOS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/schedule/*',
    scope: 'accSchedule',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SCHEDULE,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/files/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.DOCUMENTS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/sheets/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SHEETS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/specs/*',
    scope: 'accSpecs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SPECS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/share/*',
    scope: 'accDocsShare',
    modulePath: './App',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/docs/files/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.DOCUMENTS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/docs/reviews/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.REVIEWS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/docs/transmittals/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.TRANSMITTALS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/docs/settings/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SETTINGS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/docs/share/*',
    scope: 'accDocsShare',
    modulePath: './App',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/cost/files/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.DOCUMENTS,
      currentProductId: PRODUCT_IDS.COST,
    },
  },
  {
    path: '/autospecs/files/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.DOCUMENTS,
      currentProductId: PRODUCT_IDS.AUTOSPECS,
    },
  },
  {
    path: '/autospecs/home/*',
    scope: 'accAutoSpecs',
    modulePath: './HomeApp',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HOME,
      currentProductId: PRODUCT_IDS.AUTOSPECS,
    },
  },
  {
    path: '/autospecs/requirementsoverview/*',
    scope: 'accAutoSpecs',
    modulePath: './RequirementsApp',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HOME,
      currentProductId: PRODUCT_IDS.AUTOSPECS,
    },
  },
  {
    path: '/takeoff/files/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.DOCUMENTS,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },
  {
    path: '/build/submittals/*',
    scope: 'accSubmittals',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SUBMITTALS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/projects',
    scope: 'accProjectList',
    modulePath: './ProjectList',
    layout: LAYOUTS.PROJECT_DIRECTORY_LAYOUT,
  },
  {
    path: '/projects/templates',
    scope: 'accProjectList',
    modulePath: './ProjectTemplates',
    layout: LAYOUTS.PROJECT_DIRECTORY_LAYOUT,
  },
  {
    path: '/home',
    scope: 'accUserHome',
    modulePath: './UserHome',
    layout: LAYOUTS.PROJECT_DIRECTORY_LAYOUT,
  },
  {
    path: '/project-admin/template-notifications/projects/:projectId/',
    modulePath: './ProjectSettings',
    scope: 'accNotifications',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.NOTIFICATIONS,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/project-admin/notifications/projects/:projectId/',
    modulePath: './ProjectSettings',
    scope: 'accNotifications',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.NOTIFICATIONS,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/settings/projects/:projectId/notifications',
    scope: 'accNotifications',
    modulePath: './UserSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.NOTIFICATIONS,
      currentProductId: null,
      renderSideNavigation: () => null,
      showAccountsInHeader: false,
      isProductRequired: false,
    },
  },
  {
    path: '/build/handover/projects/:projectId/download',
    scope: 'accHandover',
    modulePath: './DownloadPage',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HANDOVER,
      currentProductId: PRODUCT_IDS.BUILD,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/build/handover/projects/:projectId',
    scope: 'accHandover',
    modulePath: './Handover',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HANDOVER,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/account-admin/components/accounts/:accountId/*',
    scope: 'accLibrary',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: ProjectPageLayout.VARIANTS.ACCOUNT,
      isUsersConstructionApi: true,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => {
        return (
          <RemoteSideNavigation
            scope="accAdminClient"
            module="./AccountSideNavigation"
            {...props}
          />
        );
      },
    },
  },
  {
    path: '/build/bridge/accept/:inviteId',
    scope: 'accBridge',
    modulePath: './AppAcceptInviteModal',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.BUILD,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/docs/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.DOCS,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/dc/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/project-admin/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/account-admin/templates/accounts/:accountId/*',
    scope: 'accTemplateAdmin',
    modulePath: './TemplateAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: ProjectPageLayout.VARIANTS.ACCOUNT,
      isUsersConstructionApi: true,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => {
        return (
          <RemoteSideNavigation
            scope="accAdminClient"
            module="./AccountSideNavigation"
            {...props}
          />
        );
      },
    },
  },
  {
    path: '/account-admin/projects/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: 'account',
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accAdminClient"
          module="./AccountSideNavigation"
          {...props}
        />
      ),
    },
  },
  {
    path: '/account-admin/members/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: 'account',
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accAdminClient"
          module="./AccountSideNavigation"
          {...props}
        />
      ),
    },
  },
  {
    path: '/account-admin/companies/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: 'account',
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accAdminClient"
          module="./AccountSideNavigation"
          {...props}
        />
      ),
    },
  },
  {
    path: '/account-admin/roles/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: 'account',
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accAdminClient"
          module="./AccountSideNavigation"
          {...props}
        />
      ),
    },
  },
  {
    path: '/account-admin/settings/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: 'account',
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accAdminClient"
          module="./AccountSideNavigation"
          {...props}
        />
      ),
    },
  },
  {
    path: '/account-admin/links/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: 'account',
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accAdminClient"
          module="./AccountSideNavigation"
          {...props}
        />
      ),
    },
  },
  {
    path: '/account-admin/custom-integrations/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: 'account',
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accAdminClient"
          module="./AccountSideNavigation"
          {...props}
        />
      ),
    },
  },
  {
    path: '/project-admin/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => {
        return (
          <RemoteSideNavigation
            scope="accTemplateSettings"
            module="./ProjectAdminTemplateSideNavigation"
            {...props}
          />
        );
      },
    },
  },
  {
    path: '/build/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/cost/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.COST,
    },
  },
  {
    path: '/dc/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
    },
  },
  {
    path: '/docs/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/takeoff/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },
  {
    path: '/project-admin/template-members/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateMembers',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => {
        return (
          <RemoteSideNavigation
            scope="accTemplateSettings"
            module="./ProjectAdminTemplateSideNavigation"
            {...props}
          />
        );
      },
    },
  },
  {
    path: '/build/settings/projects/:projectId',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.BUILD,
      currentToolId: TOOL_IDS.SETTINGS,
    },
  },
  {
    path: '/autospecs/settings/projects/:projectId',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.AUTOSPECS,
      currentToolId: TOOL_IDS.SETTINGS,
    },
  },
  {
    path: '/project-admin/members/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/project-admin/companies/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/project-admin/settings/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/build/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/insight/builder/accounts/:accountId/*',
    scope: 'insightBuilder',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.INSIGHT,
      currentToolId: TOOL_IDS.INSIGHT_BUILDER,
      isUsersConstructionApi: true,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="insightBuilder"
          module="./AccountSideNavigation"
          {...props}
        />
      ),
      variant: ProjectPageLayout.VARIANTS.ACCOUNT,
    },
  },
  {
    path: '/insight/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    customTitle: <TabTitle toolId={TOOL_IDS.REPORTS} />,
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: '',
      currentProductId: PRODUCT_IDS.INSIGHT,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/insight/reports/accounts/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      variant: 'account',
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.INSIGHT,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/docs/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/cost/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.COST,
    },
  },
  {
    path: '/takeoff/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },
  {
    path: '/dc/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
    },
  },
  {
    path: '/model/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.MODEL_COORDINATION,
    },
  },
  {
    path: '/cost/home/*',
    scope: 'accCost',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HOME,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/cost/budget/*',
    scope: 'accCost',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BUDGET,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/cost/cost/*',
    scope: 'accCost',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.COST,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: () => null,
    },
  },
  {
    // eslint-disable-next-line spellcheck/spell-checker
    path: '/cost/changeorder/*',
    scope: 'accCost',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.CHANGE_ORDER,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/cost/forecast/*',
    scope: 'accCost',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.FORECAST,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/cost/settings/*',
    scope: 'accCost',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.SETTINGS,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/build/issues/projects/:projectId/*',
    scope: 'accIssues',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.ISSUES,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/docs/issues/projects/:projectId/*',
    scope: 'accIssues',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.ISSUES,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/takeoff/home/projects/:projectId/*',
    scope: 'accTakeoff',
    modulePath: './Home',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.HOME,
    },
  },
  {
    path: '/takeoff/packages/projects/:projectId/*',
    scope: 'accTakeoff',
    modulePath: './Packages',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.PACKAGES,
    },
  },
  {
    path: '/takeoff/sheets/projects/:projectId/*',
    scope: 'accTakeoff',
    modulePath: './Sheets',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.SHEETS,
    },
  },
  {
    path: '/takeoff/settings/projects/:projectId/*',
    scope: 'accTakeoff',
    modulePath: './Settings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.SETTINGS,
    },
  },
  {
    path: '/model/*',
    scope: 'accModelCoordination',
    modulePath: './ExoSkeletonEntryPoint',
    excludeSubPaths: ['/model/members/*'],
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.MODEL_COORDINATION,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => {
        return (
          <RemoteSideNavigation
            scope="accModelCoordination"
            module="./ExoSideNavigation"
            {...props}
          />
        );
      },
    },
  },
] satisfies Route[];
